import { v4 as uuidv4 } from 'uuid';
import { z } from 'zod';
import { zText } from '../primitives';

export const categorySchema = z.object({
  description: z.string().nullable().default(null).optional(),
  displayIndex: z.number().nullable().default(null),
  isVisiblePos: z.boolean().default(true),
  isVisibleWeb: z.boolean().default(true),
  loyaltyCardEligible: z.boolean().nullable().default(null),
  name: z.string(),
  uuid: z.string().default(() => uuidv4()),

  createdAt: z.number().optional(),
  /** `updatedAt` is needed for highlighting changes */
  updatedAt: z.number().optional(),
});
export type Category = z.output<typeof categorySchema>;

/** Strict schema */
export const categoryStrictSchema = categorySchema.extend({
  // description: zTextNullable, // Doesn't work yet, due to .optional()
  displayIndex: z.int().nullable(),
  name: zText,
  uuid: z.guid(),
});

/** Convex schema */
export const categoryCvxSchema = categorySchema.safeExtend({
  createdAt: z.number(),
  updatedAt: z.number(),
});
export type CategoryCvx = z.output<typeof categoryCvxSchema>;
